import React, {useState, useEffect, useRef, useContext} from 'react';
import { useOverlay } from '@/OverlayContext';
import ReactDOM from 'react-dom';
import {SettingsContext} from "@/SettingsContext";

const Overlay = () => {
    const { isOverlayOpen, isOverlayVisible, closeOverlay, overlayContent, overlayTitle, overlaySubtitle, overlayImage } = useOverlay();
    const { tourSettings } = useContext(SettingsContext);

    if (!isOverlayOpen) return null;

    return ReactDOM.createPortal(
        <div className={`fixed inset-0 z-50 overscroll-none overflow-y-scroll hide-scrollbar bg-black/80 w-full ${isOverlayVisible ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}>

                <div className="sticky top-3 m-3 mt-12 float-right z-20">
                    <button
                        onClick={closeOverlay}
                        type="button"
                        className="shadow-md rounded-full text-sm p-1.5 inline-flex items-center"
                        data-modal-hide="staticModal"
                        style={{
                            backgroundColor: tourSettings.header_background_contrast_color,
                            color: tourSettings.header_text_color
                        }}
                    >
                        <svg
                            className="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" />
                        </svg>
                    </button>
                </div>

                            <div className="absolute mt-8 flex flex-col min-h-screen w-full ">


                                <div className={`flex flex-col rounded-t-3xl p-4 relative `} style={{ 
                                    backgroundColor: overlayImage ? 'transparent' : tourSettings.header_background_color,
                                    color: tourSettings.header_text_color
                                }}>
                                    {overlayImage && (
                                        <>
                                            <div className="absolute inset-0 rounded-t-3xl">
                                                <img src={overlayImage?.preview_url} alt="" className="w-full h-full object-cover rounded-t-3xl" />
                                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-t-3xl"></div>
                                            </div>
                                        </>
                                    )}
                                    <div className={`flex flex-col h-full ${overlayImage ? 'min-h-[10rem]' : 'min-h-[2rem]'} justify-between relative z-10`}>
                                        <div>
                                            {/* Meta data like score can go here */}
                                        </div>
                                        <div style={{color: overlayImage ? 'white' : tourSettings.header_text_color}}>  
                                            <p className="text-2xl line-clamp-2 mr-10">{overlayTitle}</p>
                                            <p className="text-lg line-clamp-2 leading-6">{overlaySubtitle}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex-grow overflow-y-auto w-full bg-white">
                                    {overlayContent}
                                </div>
                            </div>

        </div>,
        document.getElementById('overlay-root')
    );
};

export default Overlay;
